import { render, staticRenderFns } from "./CloseProfileSideIcon.vue?vue&type=template&id=239b1e1e&scoped=true&"
import script from "./CloseProfileSideIcon.vue?vue&type=script&lang=js&"
export * from "./CloseProfileSideIcon.vue?vue&type=script&lang=js&"
import style0 from "./CloseProfileSideIcon.vue?vue&type=style&index=0&id=239b1e1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239b1e1e",
  null
  
)

export default component.exports